
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.25 2A3.25 3.25 0 002 5.25v11.5A3.25 3.25 0 005.25 20h3.825A4 4 0 019 19.25v-.75H5.25a1.75 1.75 0 01-1.75-1.75V5.25c0-.966.784-1.75 1.75-1.75h10.5c.966 0 1.75.784 1.75 1.75V9H19V5.25A3.25 3.25 0 0015.75 2H5.25zm7.5 7h-6a.75.75 0 000 1.5h3a3.74 3.74 0 013-1.5zm-6-3a.75.75 0 000 1.5h7.5a.75.75 0 100-1.5h-7.5zM10 12.75A2.75 2.75 0 0112.75 10h6.5A2.75 2.75 0 0122 12.75v6.5A2.75 2.75 0 0119.25 22h-6.5A2.75 2.75 0 0110 19.25v-6.5zM11.5 15v4.25c0 .69.56 1.25 1.25 1.25h6.5c.69 0 1.25-.56 1.25-1.25V15h-9zm9-1.5v-.75c0-.69-.56-1.25-1.25-1.25h-6.5c-.69 0-1.25.56-1.25 1.25v.75h9z","fill":"#949494"}})])
          )
        }
      }
    